var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHobbiesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.239,
    height: 27.21,
    viewBox: "0 0 27.239 27.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8304",
    "data-name": "Group 8304",
    transform: "translate(0.25 3.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8305",
    "data-name": "Group 8305",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4652",
    "data-name": "Path 4652",
    d: "M37.094,44.524c.348,1.236-.675,2.608-2.278,3.059s-3.192-.187-3.539-1.423a1.923,1.923,0,0,1,.059-1.186.447.447,0,0,0-.539-.585l-2.228.626a1.143,1.143,0,0,0-.79,1.407l.99,3.52-.016.023a2.39,2.39,0,0,0-1.728-.191A2.5,2.5,0,0,0,25.409,51.3a3.922,3.922,0,0,0-.106,2.546c.515,1.833,2.127,2.99,3.592,2.577a2.389,2.389,0,0,0,1.377-1.067l.024.013.99,3.521a1.141,1.141,0,0,0,1.406.79h0l2.228-.626a.447.447,0,0,0,.155-.781,1.922,1.922,0,0,1-.668-.981c-.347-1.236.675-2.608,2.279-3.059s3.191.187,3.539,1.423a1.922,1.922,0,0,1-.059,1.185.448.448,0,0,0,.092.46.443.443,0,0,0,.447.126l2.228-.626a1.141,1.141,0,0,0,.789-1.407l-.99-3.52.016-.023a2.386,2.386,0,0,0,1.729.191c1.465-.412,2.237-2.238,1.722-4.072a3.925,3.925,0,0,0-1.419-2.118,2.5,2.5,0,0,0-2.174-.459,2.388,2.388,0,0,0-1.377,1.066l-.024-.013-.927-3.3a1.372,1.372,0,0,0-1.692-.949h0l-2.006.565a.447.447,0,0,0-.155.78,1.922,1.922,0,0,1,.668.98m-.4-1.346,2.006-.564a.94.94,0,0,1,1.16.65l.927,3.3a.452.452,0,0,0,.371.324.435.435,0,0,0,.436-.2,1.961,1.961,0,0,1,1.127-.878,2.081,2.081,0,0,1,1.8.392,3.492,3.492,0,0,1,1.256,1.886c.451,1.6-.187,3.191-1.423,3.539a1.962,1.962,0,0,1-1.42-.162.435.435,0,0,0-.476.057.452.452,0,0,0-.148.47l.99,3.521a.709.709,0,0,1-.49.874l-2.228.626.059.208-.075-.229a2.352,2.352,0,0,0,.069-1.451c-.412-1.466-2.237-2.238-4.071-1.723s-2.99,2.127-2.578,3.592a2.354,2.354,0,0,0,.815,1.2l0,.027-2.228.626a.71.71,0,0,1-.874-.491l-.99-3.521a.454.454,0,0,0-.371-.324.483.483,0,0,0-.066,0,.432.432,0,0,0-.37.2,1.961,1.961,0,0,1-1.127.878c-1.237.348-2.608-.675-3.059-2.278a3.491,3.491,0,0,1,.089-2.265,2.079,2.079,0,0,1,1.334-1.274,1.961,1.961,0,0,1,1.42.162.434.434,0,0,0,.476-.057.452.452,0,0,0,.147-.47l-.99-3.519a.71.71,0,0,1,.491-.874l2.228-.626-.058-.208.075.229a2.355,2.355,0,0,0-.069,1.451c.412,1.465,2.24,2.237,4.072,1.722s2.989-2.127,2.577-3.592a2.353,2.353,0,0,0-.815-1.2l-.135.169Z",
    transform: "translate(-19.71 -33.043)",
    fill: "#5066e7",
    stroke: "#5066e7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4653",
    "data-name": "Path 4653",
    d: "M1.944,15.984H6.912v-.432H1.944A1.514,1.514,0,0,1,.432,14.04V1.944A1.514,1.514,0,0,1,1.944.432h12.1a1.514,1.514,0,0,1,1.512,1.512V12.528h.432V1.944A1.946,1.946,0,0,0,14.04,0H1.944A1.946,1.946,0,0,0,0,1.944v12.1a1.946,1.946,0,0,0,1.944,1.944",
    transform: "translate(0 0)",
    fill: "#5066e7",
    stroke: "#5066e7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4655",
    "data-name": "Path 4655",
    d: "M8.944,49a1.944,1.944,0,1,0,1.944,1.944A1.944,1.944,0,0,0,8.944,49m0,3.456a1.512,1.512,0,1,1,1.512-1.512,1.512,1.512,0,0,1-1.512,1.512",
    transform: "translate(-5.488 -39.376)",
    fill: "#5066e7",
    stroke: "#5066e7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4656",
    "data-name": "Path 4656",
    d: "M8.944,7a1.944,1.944,0,1,0,1.944,1.944A1.944,1.944,0,0,0,8.944,7m0,3.456a1.512,1.512,0,1,1,1.512-1.512,1.512,1.512,0,0,1-1.512,1.512",
    transform: "translate(-5.488 -4.528)",
    fill: "#5066e7",
    stroke: "#5066e7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4657",
    "data-name": "Path 4657",
    d: "M50.944,10.888A1.944,1.944,0,1,0,49,8.944a1.944,1.944,0,0,0,1.944,1.944m0-3.456a1.512,1.512,0,1,1-1.512,1.512,1.512,1.512,0,0,1,1.512-1.512",
    transform: "translate(-38.416 -4.528)",
    fill: "#5066e7",
    stroke: "#5066e7",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbiesIcon);
export default __webpack_public_path__ + "static/media/hobbies-icon.cd870b92d768f11ee5452c2df0529401.svg";
export { ForwardRef as ReactComponent };